import { getDiscountName } from "@repo/shopify/utils/order";
import type { CartLine, ComponentizableCartLine } from "@shopify/hydrogen-react/storefront-api-types";
import React from "react";

import Price from "@atoms/Price";

export default function CheckoutLineItem({ node }: { node: CartLine | ComponentizableCartLine }) {
  const compareAtPrice = parseFloat(node.cost.compareAtAmountPerQuantity?.amount || "0") * node.quantity;
  const price = parseFloat(node.cost.amountPerQuantity.amount) * node.quantity;
  const discountPrice = parseFloat(node.cost.totalAmount.amount);

  return (
    <div className="tnt-gap-x col-span-8 grid grid-cols-2" key={node.id}>
      <span>
        {node.merchandise.product.title}
        <br />
        <span>
          {node.merchandise.title} / Qty {node.quantity}
        </span>
      </span>
      <div className="flex flex-col items-end">
        <Price
          className="text-right"
          compareAtPrice={compareAtPrice ? compareAtPrice : price}
          direction="vertical"
          price={discountPrice}
          variant="secondary"
        />
        {node.discountAllocations.length ? (
          <>
            {node.discountAllocations.map((discount) => (
              <span className="text-xs font-normal lowercase" key={getDiscountName(discount)}>
                ({getDiscountName(discount)})
              </span>
            ))}
          </>
        ) : null}
      </div>
    </div>
  );
}
